const green = Object.freeze({
    base: '#00843e',
    lighten5: '#73cd8f',
    lighten4: '#50c277',
    lighten3: '#27b75f',
    lighten2: '#1da855',
    lighten1: '#0f9549',
    darken1: '#43a047',
    darken2: '#388e3c',
    darken3: '#2e7d32',
    darken4: '#1b5e20',
    accent1: '#5ac24f',
    accent2: '#38b62a',
    accent3: '#2da720',
    accent4: '#1d9512'
  });
  const yellow = Object.freeze({
    base: '#FAE600',
    lighten5: '#fffce5',
    lighten4: '#fef7be',
    lighten3: '#fdf292',
    lighten2: '#fced65',
    lighten1: '#fae83e',
    darken1: '#f9d200',
    darken2: '#f9b900',
    darken3: '#f8a000',
    darken4: '#f77400',
    accent1: '#ffff8d',
    accent2: '#ffff00',
    accent3: '#ffea00',
    accent4: '#ffd600'
  });

  const blue = Object.freeze({
    base: '#294dff',
    lighten5: '#eaebff',
    lighten4: '#c9cbff',
    lighten3: '#a3aaff',
    lighten2: '#7888ff',
    lighten1: '#546bff',
    darken1: '#2443f3',
    darken2: '#1437e6',
    darken3: '#002adb',
    darken4: '#0003cb',
    accent1: '#82d5ff',
    accent2: '#4fc5ff',
    accent3: '#29b8ff',
    accent4: '#0dabfe'
  });
  const orange = Object.freeze({
    base: '#FF7907',
    lighten5: '#ffea49',
    lighten4: '#ffe51d',
    lighten3: '#ffd823',
    lighten2: '#ffbf1c',
    lighten1: '#ffa615',
    darken1: '#fb8c00',
    darken2: '#f57c00',
    darken3: '#ef6c00',
    darken4: '#e65100',
    accent1: '#ffd180',
    accent2: '#ffab40',
    accent3: '#ff9100',
    accent4: '#ff6d00'
  });
  const pink = Object.freeze({
    base: '#c30054',
    lighten5: '#f7e1e9',
    lighten4: '#ebb4ca',
    lighten3: '#de83a7',
    lighten2: '#d25385',
    lighten1: '#ca2e6c',
    darken1: '#b30051',
    darken2: '#9e004c',
    darken3: '#890047',
    darken4: '#65003d',
    accent1: '#ffb7ce',
    accent2: '#ff86ad',
    accent3: '#ff4e8b',
    accent4: '#ff0370'
  });
  const peach = Object.freeze({
    base: '#f84724',
    lighten5: '#fae8e6',
    lighten4: '#fdc8bb',
    lighten3: '#fba590',
    lighten2: '#fa8164',
    lighten1: '#f96443',
    darken1: '#ed4120',
    darken2: '#e03a1c',
    darken3: '#d13317',
    darken4: '#b8260e',
    accent1: '#ffcab9',
    accent2: '#ffa68c',
    accent3: '#ff815d',
    accent4: '#ff6238'
  });
  
  const purple = Object.freeze({
    base: '#7d57e1',
    lighten5: '#eeecff',
    lighten4: '#d5ceff',
    lighten3: '#b8afff',
    lighten2: '#9d8ff9',
    lighten1: '#8b73ed',
    darken1: '#764dd5',
    darken2: '#6d41c8',
    darken3: '#6635ba',
    darken4: '#5a1ca3',
    accent1: '#cec0e8',
    accent2: '#ae97d9',
    accent3: '#754dc0',
    accent4: '#5b2eb5'
  });

  const grey = Object.freeze({
    base: '#9e9e9e',
    lighten5: '#fafafa',
    lighten4: '#f5f5f5',
    lighten3: '#eeeeee',
    lighten2: '#e0e0e0',
    lighten1: '#bdbdbd',
    darken1: '#757575',
    darken2: '#616161',
    darken3: '#424242',
    darken4: '#212121'
  });
  const shades = Object.freeze({
    black: '#000000',
    white: '#ffffff',
    transparent: 'transparent'
  });
 


  export default Object.freeze({
    pink,
    purple,
    blue,
    green,
    yellow,
    orange,
    peach,
    grey,
    shades
  });
  //# sourceMappingURL=colors.js.map